module.exports = __webpack_public_path__ + "img/g_mro_13.2453931c.png";